// extracted by mini-css-extract-plugin
export default {"customBox":"styles_customBox__7Sr9o","contentBox":"styles_contentBox__B0tSt","headingBox":"styles_headingBox__cRfoq"};